import { styled } from "@mui/material/styles";
import { MediaQuerys } from "../../../styles/GlobalStyle";

const { mobile, tablet, desktop } = MediaQuerys;

export const ContainerCell = styled('div')(() => ({
    display: 'flex',
    gap: '0.75rem',
    alignItems: 'center',
}))

export const SectionInfo = styled('section')(() => ({
    display: 'flex',
    width: 'max-content',
    flexDirection: 'column',
}))

export const InfoCell = styled('div')(() => ({
    lineHeight: 1,
    fontSize: '14px',
    overflow: 'hidden',
    display: '-webkit-box',
    maxWidth: 150,
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
    [tablet]: {
        fontSize: '12px',
    }
}))
